import React from 'react';

import type {FC} from 'react';


export const ErpAdminScopesDisplay: FC = () => (<div> There are no conditions for the ERP Admin</div>);

export default ErpAdminScopesDisplay;
